module.exports = __webpack_public_path__ + "static/media/News-01.e5bb4db1.png";